import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {Dispatch, SetStateAction} from "react";
import Form from 'react-bootstrap/Form';

interface RowsPerPageProps {
    rowsPerPage : number
    setRowsPerPage?: Dispatch<SetStateAction<number>>
    setCurrentPage?: Dispatch<SetStateAction<number>>
    maxRowsPerPage?: number
}

export const RowsPerPage = ({rowsPerPage, setRowsPerPage, setCurrentPage, maxRowsPerPage = 160} : RowsPerPageProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    const onChangeRowsPerPage = (newRowsPerPage : number) =>
    {
        if (setRowsPerPage !== undefined) {
            setRowsPerPage(newRowsPerPage);
        }

        // reset the current page because the old page might not exist
        if (setCurrentPage !== undefined) {
            setCurrentPage(1);
        }
    }


    const addOption = (rowsPerPage : number)=>
    {
        return (
            rowsPerPage <= maxRowsPerPage && <option value={rowsPerPage}>{rowsPerPage}</option>
        )
    }

    return (
        <Form.Select className="cm-rows-per-page"
                     value={rowsPerPage}
                     title={t("pager.rows-per-page")}
                     onChange={(e) => onChangeRowsPerPage(Number(e.target.value))}
        >
            {addOption(5)}
            {addOption(10)}
            {addOption(20)}
            {addOption(40)}
            {addOption(80)}
            {addOption(160)}
        </Form.Select>
    )
}
